import { APPOINTMENT_STATUSES } from 'features/order-tracker/utils/entries/appointmentStatuses';

export const statuses = {
  [APPOINTMENT_STATUSES.CustomerMissed]: 'customerMissed',
  [APPOINTMENT_STATUSES.SupplierMissed]: 'supplierMissed',
  [APPOINTMENT_STATUSES.Completed]: 'completed',
  [APPOINTMENT_STATUSES.Booked]: 'booked',
  [APPOINTMENT_STATUSES.Closed]: 'closed',
  [APPOINTMENT_STATUSES.SupplierDelayed]: 'supplierDelayed',
  [APPOINTMENT_STATUSES.AtRisk]: 'atRisk',
  [APPOINTMENT_STATUSES.Confirmed]: 'confirmed',
  [APPOINTMENT_STATUSES.ReAppointEUMissed]: 'reAppointEUMissed',
  [APPOINTMENT_STATUSES.ReAppointORMissed]: 'reAppointORMissed',
};

export const statusesText = {
  [APPOINTMENT_STATUSES.CustomerMissed]: 'Action needed',
  [APPOINTMENT_STATUSES.SupplierMissed]: 'Missed',
  [APPOINTMENT_STATUSES.Completed]: 'Done',
  [APPOINTMENT_STATUSES.Booked]: 'Requested',
  [APPOINTMENT_STATUSES.Closed]: 'Done',
  [APPOINTMENT_STATUSES.SupplierDelayed]: 'Incomplete',
  [APPOINTMENT_STATUSES.AtRisk]: 'Booked',
  [APPOINTMENT_STATUSES.Confirmed]: 'Booked',
  [APPOINTMENT_STATUSES.ReAppointEUMissed]: 'Missed',
  [APPOINTMENT_STATUSES.ReAppointORMissed]: 'Missed',
  [APPOINTMENT_STATUSES.SupplierChanged]: 'Booked',
  [APPOINTMENT_STATUSES.Rejected]: 'Booked',
};

export const statusPONR = 'In progress';
